module.exports = __webpack_public_path__ + "4f79b2820f74267c2968d66abbc1fd20.png";